import { PassengerDto } from '@sd-portal/shared/passenger';

export class FlightPassenger {
  flightPassengerId: number = 0;
  passenger?: PassengerDto;
  // flags
  isLeadPassenger: boolean = false;
  // FKs
  businessCategoryId?: number;
  departmentId?: number;
  flightId: number = 0;
  passengerStatusId?: number;
  isLapChild: boolean = false;
  isLapChildEnabled: boolean = false;
  // index signature
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}
